import React from "react";
import "../ViewAdmision/ViewAdmision.css";

function ViewAdmission({ admission, onClose }) {
  // Format the DOB
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="view-container">
      <div className="view">
        <div className="view-header">
          <h2>Admission Details</h2>
        </div>
        <div className="view-details">
          <p>
            <strong>Student ID:</strong> {admission.id}
          </p>
          <p>
            <strong>Student Name:</strong> {admission.student_name}
          </p>
          <p>
            <strong>Class:</strong> {admission.class_name}
          </p>
          <p>
            <strong>Section:</strong>
            {admission.section}
          </p>
          <p>
            <strong>Gender:</strong> {admission.gender}
          </p>
          <p>
            <strong>DOB:</strong> {formatDate(admission.dob)}
          </p>
          <p>
            <strong>Blood Group:</strong> {admission.student_blood_group}
          </p>
          <p>
            <strong>Mother Tongue:</strong> {admission.mother_tongue}
          </p>
          <p>
            <strong>Nationality:</strong> {admission.nationality}
          </p>
          <p>
            <strong>Address:</strong> {admission.address}
          </p>
          <p>
            <strong>Home Town:</strong> {admission.home_town}
          </p>
          <p>
            <strong>Caste:</strong> {admission.caste}
          </p>
          <p>
            <strong>Academic Year:</strong> {admission.academic_year}
          </p>
          <p>
            <strong>Student Aadhar:</strong> {admission.student_aadhar}
          </p>

          <p>
            <strong>Father Name:</strong> {admission.father_name}
          </p>
          <p>
            <strong>Father Occupation:</strong> {admission.father_occupation}
          </p>
          <p>
            <strong>Father Email:</strong> {admission.father_email}
          </p>
          <p>
            <strong>Father Phone:</strong> {admission.father_phone}
          </p>
          <p>
            <strong>Father Aadhar:</strong> {admission.father_aadhar}
          </p>
          <p>
            <strong>Mother Name:</strong> {admission.mother_name}
          </p>
          <p>
            <strong>Mother Occupation:</strong> {admission.mother_occupation}
          </p>
          <p>
            <strong>Mother Email:</strong> {admission.mother_email}
          </p>
          <p>
            <strong>Mother Phone:</strong> {admission.mother_phone}
          </p>
          <p>
            <strong>Mother Aadhar:</strong> {admission.mother_aadhar}
          </p>

          <p>
            <strong>Guardian Name:</strong> {admission.guardian_name}
          </p>
          <p>
            <strong>Guardian Email:</strong> {admission.guardian_email}
          </p>
          <p>
            <strong>Guardian Phone:</strong> {admission.guardian_phone}
          </p>
          <p>
            <strong>Guardian Aadhar:</strong> {admission.guardian_aadhar}
          </p>
        </div>
        <div className="view-actions">
          <button className="view-cancel" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewAdmission;
